import type { NationalIdRules } from '../types';

const digitsOnly = (value: string): string => value.replace(/\D/g, '');

const hasAllSameDigits = (digits: string): boolean => /^(\d)\1+$/.test(digits);

const calcCpfCheckDigit = (digits: string, factorStart: number): number => {
  let sum = 0;
  for (let i = 0; i < digits.length; i += 1) {
    sum += parseInt(digits[i], 10) * (factorStart - i);
  }
  const remainder = (sum * 10) % 11;
  return remainder === 10 ? 0 : remainder;
};

const validateBrazilianCpf = (value: string): boolean => {
  const digits = digitsOnly(value);
  if (digits.length !== 11 || hasAllSameDigits(digits)) {
    return false;
  }
  const d1 = calcCpfCheckDigit(digits.slice(0, 9), 10);
  const d2 = calcCpfCheckDigit(digits.slice(0, 10), 11);
  return digits.endsWith(`${d1}${d2}`);
};

const normalizeBrazilianCpf = (value: string): string => digitsOnly(value);

const formatBrazilianCpf = (value: string): string => {
  const digits = digitsOnly(value);
  if (digits.length !== 11) {
    return digits || '';
  }
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

export const brazilNationalId: NationalIdRules = {
  countryCode: 'BR',
  documentKind: 'CPF',
  labelKey: 'country.brazil.idCard',
  invalidKey: 'country.brazil.idCard.invalid',
  placeholder: '123.456.789-09',
  mask: '###.###.###-##',
  normalize: normalizeBrazilianCpf,
  format: formatBrazilianCpf,
  validate: validateBrazilianCpf,
  searchToken: (value: string) => digitsOnly(value),
};
